import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CheckoutDireto from "./CheckoutDireto";
import CheckoutOferta from "./CheckoutOferta";
import useIsAppWebView from "hooks/useIsAppWebView";

const CheckoutViews = () => {
	// No app do profissional (WebView), checkout do plano SaaS é
	// inacessível: compra dentro do app viola a política de In-App
	// Purchase da Apple (guideline 3.1.1).
	const isAppWebView = useIsAppWebView();

	return (
		<Switch>
			{/* Funil v3: CheckoutOferta trata o isAppWebView por dentro (tela
			    neutra explicando pagar pela web), então NÃO redireciona aqui. */}
			<Route path="/checkout-oferta" component={CheckoutOferta} />
			<Route
				path="/checkout/:planoId"
				render={() =>
					isAppWebView ? <Redirect to="/" /> : <CheckoutDireto />
				}
			/>
		</Switch>
	);
};

export default CheckoutViews;
